import MissionSection from './About/MissionSection';
import WhyChooseSection from './About/WhyChooseSection';

const About = () => (
  <section id="apropos" className="about-section">
    <div className="container">
      <MissionSection />
      <WhyChooseSection />
    </div>
  </section>
);

export default About;